
import { Component, Vue } from 'vue-property-decorator'
import SwitchBlock from "../../ozon/components/SwitchBlock/SwitchBlock.vue";

@Component({ components: {
	SwitchBlock,
} })
export default class KionSubscriptionsNew extends Vue {
}
